import React from "react";
import styled from "styled-components";
import { string, bool } from "prop-types";

import { usePrimaryColor } from "@hooks/usePrimaryColor";

import RadioIcon from "./Icons/RadioIcon";
import Typography from "@components/shared/Typography";
import { fontSize } from "@components/shared/utils";
import { withTabNavigation } from "@hoc/withTabNavigation";

const StyledLabel = styled.label`
  align-items: center;
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.grey : theme.colors.black};
  display: flex;
  cursor: ${({ disabled }) => !disabled && "pointer"};
  user-select: none;
  width: ${({ fullWidth }) => fullWidth && "100%"};
  position: relative;
`;

const StyledLabelWrapper = withTabNavigation(
  styled.div`
    display: flex;
    align-items: center;
  `,
  "button"
);

const StyledInput = styled.input`
  display: none;
`;

const StyledRadioIcon = styled(RadioIcon)`
  background: transparent;
  margin-right: 1rem;
`;

const StyledTypography = styled(Typography)`
  font-size: ${fontSize("md")};
  margin: 0;
`;

const Radio = ({
  label,
  fullWidth = false,
  disabled,
  className,
  checked,
  hideInput,
  dataId,
  labelAsHeader = false,
  ...props
}) => {
  const primaryColor = usePrimaryColor();

  return (
    <StyledLabel
      disabled={disabled}
      fullWidth={fullWidth}
      className={className}
      data-id={dataId}
    >
      <StyledLabelWrapper>
        {!hideInput && (
          <>
            <StyledInput
              primaryColor={primaryColor}
              type="radio"
              disabled={disabled}
              checked={checked}
              {...props}
            />
            <StyledRadioIcon checked={checked} />
          </>
        )}
        <StyledTypography as={labelAsHeader && "h3"}>{label}</StyledTypography>
      </StyledLabelWrapper>
    </StyledLabel>
  );
};

Radio.propTypes = {
  label: string.isRequired,
  fullWidth: bool,
  disabled: bool,
  className: string,
  checked: bool,
  hideInput: bool,
  dataId: string,
  labelAsHeader: bool,
};

export default Radio;
